import jQuery from 'jquery';
import VimeoPlayer from '@vimeo/player';
import MobileDetect from 'mobile-detect';

const $ = jQuery;
const md = new MobileDetect(window.navigator.userAgent);
const vimeoUrl = 'https://player.vimeo.com/video/';
const heroWrapper = document.querySelector('.js-hero');
const heroVideoMobileUrl = heroWrapper?.dataset.videoMobileUrl;

const loadNativeVideo = () => {
  const mediaQuery = window.matchMedia('(max-width: 600px)').matches;
  const nativeVideoContainer = document.querySelector('.js-native-video');
  const nativeVideoMobile = heroVideoMobileUrl && nativeVideoContainer && nativeVideoContainer.querySelector('.js-native-video-mobile');
  const nativeVideoDesktop = nativeVideoContainer?.querySelector('.js-native-video-desktop');
  const soundButton = document.querySelector('.js_sound');
  const videoVisibleClass = 'is-visible';

  if (!nativeVideoContainer || !nativeVideoDesktop) return;

  soundButton.addEventListener('click', () => {
    soundButton.classList.toggle('mute');
    nativeVideoDesktop.muted = !nativeVideoDesktop.muted;
  });

  if (mediaQuery && nativeVideoMobile) {
    nativeVideoMobile.classList.add(videoVisibleClass);
    nativeVideoDesktop.classList.remove(videoVisibleClass);
  } else {
    if (nativeVideoMobile) {
      nativeVideoMobile.classList.remove(videoVisibleClass);
    }

    nativeVideoDesktop.classList.add(videoVisibleClass);
  }
};

const heroVideo = () => {
  $('.js-vimeo-player').each(function vimeoPlayers() {
    const hero = $(this).parent().parent();
    const videoID = $(this).attr('id');
    const soundButton = $(this).parent().find('.js_sound');
    const videoMobileUrl = hero.attr('data-video-mobile-url');
    const videoMobileImage = hero.attr('data-image-mobile');
    const playButton = $('.js_play_video');
    const videoMobileID = videoMobileUrl.replace(vimeoUrl, '');
    let player = null;

    if (!videoID) return;

    // On mobile update the video image and id for mobile
    if (md.mobile() && videoMobileUrl && videoMobileImage) {
      hero.css('background-image', `url(${videoMobileImage})`);
      $(this).attr('id', videoMobileID);

      player = new VimeoPlayer(videoMobileID, {
        id: videoMobileID,
        autoplay: false,
        controls: false,
        portrait: true,
        muted: true,
      });
    } else {
      hero.css('background-image', '');
      $(this).attr('id', videoID);

      player = new VimeoPlayer(videoID, {
        id: videoID,
        loop: true,
        background: true,
        muted: true,
      });
    }

    soundButton.on('click', function soundIconToggle() {
      $(this).toggleClass('mute');
      if ($(this).hasClass('mute')) {
        player.setVolume(0);
      } else {
        player.setVolume(1);
      }
    });

    playButton.on('click', () => {
      if (md.mobile()) {
        $('.c-hero-homepage').addClass('playing');
        player.play();
      }
    });

    // On window resize change the video image and id for mobile and desktop
    $(window).resize(() => {
      const viewportWidth = $(window).width();
      if (viewportWidth <= 600 && videoMobileUrl && videoMobileImage) {
        hero.css('background-image', `url(${videoMobileImage})`);
        $(this).attr('id', videoMobileID);
      } else {
        hero.css('background-image', '');
        $(this).attr('id', videoID);
      }
    });
  });

  loadNativeVideo();
  window.addEventListener('resize', loadNativeVideo);
};

export default heroVideo;
